module.exports = __webpack_public_path__ + "img/home-icon.aef24ff1.svg";